import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CursosComponent } from './cursos.component';
// import { GrupoUsuariosComponent } from './cursos.component';
// import { FlujosTrabajoComponent } from './flujos-trabajo.component';



const routes: Routes = [
    {
        path: '',
        component: CursosComponent
    },
    // {
    //     path: 'servicios',
    //     component: ContactosComponent
    // },
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule] 
})
export class CursosRoutingModule { }